import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import HorizontalChart from './icon-horizontal-chart.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <HorizontalChart {...validProps} />;
}
SvgComponent.iconName = 'horizontalChart';

export const HorizontalChartIcon = svgIconWrapper(SvgComponent);
